import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ItonicsAuthService } from '../../../services/itonicsAuth.service';
import { CognitoAuthService } from '../../../services/cognitoAuth.service';

@Component({
  selector: 'logout',
  template: ''
})
export class LogoutComponent implements OnInit {
  constructor(
    private cognitoAuthService: CognitoAuthService,
    private itonicsAuthService: ItonicsAuthService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params.tenant) {
        window.location.href = this.cognitoAuthService.createLogoutUrl(ItonicsAuthService.AuthSystemUrl);
      } else {
        window.location.href = ItonicsAuthService.AuthSystemUrl;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/user/sign-in/logout.component.ts